const API_URL = import.meta.env.VITE_API_URL || '/api';

// Ленивый импорт trackError — чтобы не создавать циклических зависимостей
let _trackError = null;
function getTrackError() {
  if (!_trackError) {
    try {
      const mod = import('./userActivity.js');
      mod.then(m => { _trackError = m.trackError; });
    } catch { /* ignore */ }
  }
  return _trackError;
}
// Предзагрузка
getTrackError();

export async function apiClient(endpoint, options = {}) {
  const token = localStorage.getItem('token');
  const activePvzId = localStorage.getItem('wb_active_pvz_id');
  
  let pvzHeaderValue = activePvzId || '';
  try {
    const savedIds = localStorage.getItem('wb_selected_pvz_ids');
    if (savedIds) {
      const parsedIds = JSON.parse(savedIds);
      if (Array.isArray(parsedIds) && parsedIds.length > 0) {
        pvzHeaderValue = parsedIds.join(',');
      }
    }
  } catch (e) {
    console.warn('Failed to parse selected PVZs from local storage:', e);
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(pvzHeaderValue ? { 'X-Pvz-Id': pvzHeaderValue } : {}),
    ...options.headers,
  };

  // Retry логика для устойчивости к медленным соединениям
  const maxRetries = 1;
  const timeout = 15000; // 15 секунд (было 30с — слишком долго для мобильных)
  let lastError;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers,
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (response.status === 401) {
        localStorage.removeItem('token');
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
          return {};
        }
      }

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const trackErr = _trackError || getTrackError();
        if (trackErr) {
          trackErr(data.error || `API ${response.status}`, {
            endpoint,
            status: response.status,
            method: options.method || 'GET',
          });
        }
        throw new Error(data.error || 'Ошибка сети');
      }

      return data;
    } catch (err) {
      clearTimeout(timeoutId);
      lastError = err;

      // Retry только при таймауте или сетевой ошибке, не при бизнес-ошибках
      if (err.name === 'AbortError' || err.message === 'Failed to fetch') {
        if (attempt < maxRetries) {
          // Ждём перед следующей попыткой (500ms, 1500ms)
          await new Promise(r => setTimeout(r, 500 * (attempt + 1)));
          continue;
        }
        throw new Error('Превышено время ожидания ответа от сервера');
      }
      throw err;
    }
  }

  throw lastError;
}

export default apiClient;

